import { setLeaderboard } from "Store/features/public/publicPuzzleSlice";
import { SERVER_URL } from "../../Util/constants";

import {
  startRequest,
  submitRequestSuccess,
  clearRequestStatus,
  setRecentlyCreatedPuzzle,
} from "Store/features/stateSlice";
import { REQUESTS } from "Util/constants";

const makeSavePuzzleRequest = async (dispatch, authToken, savePuzzleParams) => {
  dispatch(startRequest(REQUESTS.SAVE_PUZZLE));
  const response = await fetch(`${SERVER_URL}/portal/puzzle`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": authToken,
    },
    body: JSON.stringify(savePuzzleParams),
  });
  const puzzle = await response.json();
  dispatch(setRecentlyCreatedPuzzle(puzzle));
  dispatch(submitRequestSuccess(REQUESTS.SAVE_PUZZLE));
  setTimeout(() => dispatch(clearRequestStatus(REQUESTS.SAVE_PUZZLE)), 1000);

  return;
};

const makeDeletePuzzleRequest = async (
  dispatch,
  authToken,
  deletePuzzleParams
) => {
  dispatch(startRequest(REQUESTS.DELETE_PUZZLE));
  const response = await fetch(`${SERVER_URL}/portal/puzzle/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": authToken,
    },
    body: JSON.stringify(deletePuzzleParams),
  });
  dispatch(submitRequestSuccess(REQUESTS.DELETE_PUZZLE));
  setTimeout(() => dispatch(clearRequestStatus(REQUESTS.DELETE_PUZZLE)), 1000);
  return response.status;
};

const localDevPuzzles = {
  "": null,
  "6eaefe71-c24a-4359-a438-f72acdb5787a": {
    id: "6eaefe71-c24a-4359-a438-f72acdb5787a",
    type: "newsie",
    org: "9d77d808-da36-4f66-ac47-c2b48a825d8b",
    puzzle: {
      takeawayPoints: [
        "Kamala Harris chose Tim Walz as her running mate for his familiar figure to voters.",
        "Tim Walz brings Midwestern dad energy to the presidential campaign.",
        "Walz's political arc shifted from moderate to progressive populist.",
        "Walz's personal touch and good vibes helped him secure the vice-presidential role.",
        "Walz needs to translate his popularity to excite Democrats in small towns and rural areas.",
        "Harris's choice of Walz relieved some Republicans who saw him as a weaker opponent.",
        "Walz's record may face criticism for certain decisions and responses.",
      ],
      newsieInput: [
        ["Harris", "Walz", "Familiar"],
        ["Midwestern", "Energy", "Campaign"],
        ["Moderate", "Progressive", "Populist"],
        ["Personal", "Vibes", "Role"],
        ["Translate", "Popularity", "Excite"],
        ["Relieved", "Republicans", "Opponent"],
        ["Criticism", "Decisions", "Responses"],
      ],
    },
  },
  "2381ab5d-a8bb-4c31-823f-773bdaa9255d": {
    id: "2381ab5d-a8bb-4c31-823f-773bdaa9255d",
    type: "wordsearch",
    org: "9d77d808-da36-4f66-ac47-c2b48a825d8b",
    puzzle: {
      words: [
        "KAMALA",
        "HARRIS",
        "WALZ",
        "MINNESOTA",
        "PROGRESSIVE",
        "VICE",
        "PRESIDENT",
        "MIDWEST",
        "GOVERNOR",
        "CAMPAIGN",
      ],
      grid: [
        ["P", "R", "E", "S", "I", "D", "E", "N", "T", "T"],
        ["E", "I", "P", "S", "N", "H", "U", "H", "J", "S"],
        ["V", "C", "M", "C", "A", "C", "D", "U", "Z", "E"],
        ["W", "I", "I", "R", "A", "W", "L", "M", "L", "W"],
        ["D", "T", "R", "V", "I", "L", "A", "J", "X", "D"],
        ["F", "I", "T", "D", "R", "Y", "A", "L", "A", "I"],
        ["S", "F", "J", "V", "W", "K", "I", "M", "Z", "M"],
        ["C", "A", "M", "P", "A", "I", "G", "N", "A", "S"],
        ["A", "T", "O", "S", "E", "N", "N", "I", "M", "K"],
        ["Q", "J", "G", "O", "V", "E", "R", "N", "O", "R"],
      ],
    },
  },
  "47fd8581-99af-4680-b6b1-c69523eb44c2": {
    id: "47fd8581-99af-4680-b6b1-c69523eb44c2",
    type: "crossword",
    org: "9d77d808-da36-4f66-ac47-c2b48a825d8b",
    puzzle: {
      wordsAndClues: [
        {
          word: "Pelvic",
          clue: "Area related to women's health physical therapy",
        },
        {
          word: "Origin",
          clue: "Premiere provider of Pelvic Floor and Women’s Health Physical Therapy",
        },
        {
          word: "Playground",
          clue: "Brand exceeding expectations in sexual health and pleasure",
        },
        {
          word: "Contraline",
          clue: "Company with a hydrogel implant blocking sperm for a year",
        },
        {
          word: "AuntFlow",
          clue: "Company supporting free period products in schools",
        },
        {
          word: "Evvy",
          clue: "Advocating for inclusive research and publishing a book on gender health gap",
        },
        {
          word: "HerMD",
          clue: "Co-Founder Somi Javaid made Inc's Female Founders 250 List",
        },
        {
          word: "Fortune",
          clue: "Host of Women's Health Lunch in conjunction with Brainstorm Health Conference",
        },
        {
          word: "MedCity",
          clue: "Host of INVEST Tech Conference in Chicago",
        },
        {
          word: "HeyJane",
          clue: "Company supported by Amboy Street with founder Kiki Freedman",
        },
      ],
      grid: [
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "P",
            clueNumber: 1,
            letter: "",
          },
          {
            answer: "l",
            letter: "",
          },
          {
            answer: "a",
            letter: "",
          },
          {
            answer: "y",
            letter: "",
          },
          {
            answer: "g",
            letter: "",
          },
          {
            answer: "r",
            letter: "",
          },
          {
            answer: "o",
            letter: "",
          },
          {
            answer: "u",
            letter: "",
          },
          {
            answer: "n",
            letter: "",
          },
          {
            answer: "d",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "H",
            clueNumber: 5,
            letter: "",
          },
          {
            answer: "e",
            letter: "",
          },
          {
            answer: "r",
            letter: "",
          },
          {
            answer: "M",
            letter: "",
          },
          {
            answer: "D",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "A",
            clueNumber: 3,
            letter: "",
          },
          {
            answer: "u",
            letter: "",
          },
          {
            answer: "n",
            letter: "",
          },
          {
            answer: "t",
            letter: "",
          },
          {
            answer: "F",
            letter: "",
          },
          {
            answer: "l",
            letter: "",
          },
          {
            answer: "o",
            letter: "",
          },
          {
            answer: "w",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "E",
            clueNumber: 4,
            letter: "",
          },
          {
            answer: "v",
            letter: "",
          },
          {
            answer: "v",
            letter: "",
          },
          {
            answer: "y",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "O",
            clueNumber: 2,
            letter: "",
          },
          {
            answer: "r",
            letter: "",
          },
          {
            answer: "i",
            letter: "",
          },
          {
            answer: "g",
            letter: "",
          },
          {
            answer: "i",
            letter: "",
          },
          {
            answer: "n",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "c",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
        [
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
          {
            answer: "",
            letter: "",
          },
        ],
      ],
      clues: {
        across: [
          {
            number: 2,
            position: {
              col: 1,
              row: 12,
            },
            word: "Origin",
            clue: "Premiere provider of Pelvic Floor and Women’s Health Physical Therapy",
          },
          {
            number: 1,
            position: {
              col: 5,
              row: 8,
            },
            word: "Playground",
            clue: "Brand exceeding expectations in sexual health and pleasure",
          },
          {
            number: 3,
            position: {
              col: 0,
              row: 10,
            },
            word: "AuntFlow",
            clue: "Company supporting free period products in schools",
          },
          {
            number: 4,
            position: {
              col: 4,
              row: 11,
            },
            word: "Evvy",
            clue: "Advocating for inclusive research and publishing a book on gender health gap",
          },
          {
            number: 5,
            position: {
              col: 4,
              row: 9,
            },
            word: "HerMD",
            clue: "Co-Founder Somi Javaid made Inc's Female Founders 250 List",
          },
        ],
        down: [
          {
            number: 1,
            position: {
              col: 5,
              row: 8,
            },
            word: "Pelvic",
            clue: "Area related to women's health physical therapy",
          },
        ],
      },
    },
  },
};

const makeSubmitPuzzleTextRequest = async (
  dispatch,
  puzzleType,
  contentText,
  questions,
  authToken
) => {
  dispatch(startRequest(REQUESTS.SUBMIT_PUZZLE_TEXT));
  const response = await fetch(`${SERVER_URL}/${puzzleType}/dynamic`, {
    method: "POST",
    headers: {
      "Content-Type": "text/plain",
      // TODO: DO NOT DEPLOY Silly
      "x-auth-token": authToken,
      ...(questions ? { questions } : {}),
    },
    body: contentText,
  });
  const submitPuzzleResult = await response.json();
  dispatch(submitRequestSuccess(REQUESTS.SUBMIT_PUZZLE_TEXT));
  // setTimeout(
  //   () => dispatch(clearRequestStatus(REQUESTS.SUBMIT_PUZZLE_TEXT)),
  //   10000
  // );
  return submitPuzzleResult;
};

// Public
const makeGetPuzzleRequest = async (dispatch, puzzleId, postcastAuthToken) => {
  dispatch(startRequest(REQUESTS.GET_PUZZLE));
  // return localDevPuzzles[puzzleId];

  const response = await fetch(`${SERVER_URL}/portal/puzzle/${puzzleId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(postcastAuthToken ? { "x-auth-token": postcastAuthToken } : {}),
    },
  });
  dispatch(submitRequestSuccess(REQUESTS.GET_PUZZLE));
  setTimeout(() => dispatch(clearRequestStatus(REQUESTS.GET_PUZZLE)), 1000);
  if (response.status === 200) return await response.json();
  return null;
};

// Public User
const recordUserGameStat = async (publicUserAuthToken, puzzleId, score, dispatch) => {
  // dispatch(startRequest(REQUESTS.SUBMIT_PUZZLE_TEXT));
  const response = await fetch(`${SERVER_URL}/puzzle/complete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": publicUserAuthToken,
    },
    body: JSON.stringify({
      puzzleId,
      score
    }),
  });
  if (response.status !== 200) {
    console.error("Failed to record user game stat")
    return [];
  }
  const submitPuzzleResult = await response.json();
  dispatch(setLeaderboard(submitPuzzleResult))
  // dispatch(submitRequestSuccess(REQUESTS.SUBMIT_PUZZLE_TEXT));
  return submitPuzzleResult;
};

export {
  makeSavePuzzleRequest,
  makeDeletePuzzleRequest,
  makeGetPuzzleRequest,
  makeSubmitPuzzleTextRequest,
  recordUserGameStat,
};
